(function($, undefined) {

	'use strict';
	var sitekey = '6LeEFbIUAAAAAAhlXZ0teARuHaeTX037HcGWI3y9';

	
	/* RECAPTCHA UTIL FUNCTION */
	/**
	 * Render recaptchas dynamically.
	 * @param   btn         An element referencing the button or a string 
	 *                      referencing the Id of the element.
	 * @param   callback    A function to be called after recaptcha has 
	 *                      completed its check. The function is passed back
	 *                      the recaptcha response and the form element.
	 * @param   validate    (optional) A boolean to know if a form needs to be 
	 *                      validated using the formValidator in com/form.js.
	 * @param   form        (optional) A jQuery object reference the form to be
	 *                      validated using formValidator in com/form.js.
	 */

	var recaptcha = function(btn, callback, validate, form) {
		if(btn && window.grecaptcha) {
			if (window.grecaptcha.render) {
				grecaptcha.render(btn, {
					'sitekey' : sitekey,
					'callback' : function(response) {
						var formValidator = Fw.component.models().form.validateForm;
						var validated = true;
						if(validate) {
							validated = false;	
							formValidator(form);
							if(!form.hasClass('has-error')) {
								validated = true;
							}
						}
						
						if(validated) {
							callback(response, form);
						} else {
							grecaptcha.reset();
						}
					},
					'badge': 'inline'
				});
			} else {
				setTimeout(function() {
					recaptcha(btn, callback, validate, form);
				}, 250);
			}
		} else if(btn && !window.grecaptcha) {
			setTimeout(function() {
				recaptcha(btn, callback, validate, form);
			}, 250);
		}
	};

	var updateItemTop = function(extraOffset, item, ctn, outerCtn) {
		ctn.each(function() {
			var t = $(this);
			var outerCtnHeight = t.closest(outerCtn).outerHeight();

			if (t.closest(outerCtn) !== null && outerCtnHeight > $(window).height()) {
				var ctnHeight = t.outerHeight();
				var itemOffset = t.offset().top;
				var imgHeight = t.find(item).outerHeight();
				var	windowTop = $(window).scrollTop();
				
				var addedOffset = ((windowTop - itemOffset) + $('.site-header').outerHeight()) + extraOffset;

				if ((windowTop >= (itemOffset - $('.site-header').outerHeight()))) {
					if ((addedOffset + imgHeight) <= ctnHeight) {
						t.find(item).css('top', addedOffset + 'px');
					} else {
						t.find(item).css('top', (ctnHeight - imgHeight) + 'px');
					}
				} else {
					t.find(item).css('top', '0px');
				}
			} else {
				t.find(item).css('top', '0px');
			}
		});
	};

	var decodeText = function(text) {
        if (text !== undefined) {
            return text
                .replace(/\\xE0/g, '\xE0')
                .replace(/\\xE2/g, '\xE2')
                .replace(/\\xE3/g, '\xE3')
                .replace(/\\xE4/g, '\xE4')
                .replace(/\\xE5/g, '\xE5')
                .replace(/\\xE7/g, '\xE7')
                .replace(/\\xE9/g, '\xE9')
                .replace(/\\xE8/g, '\xE8')
                .replace(/\\xEA/g, '\xEA')
                .replace(/\\xEB/g, '\xEB')
                .replace(/\\xED/g, '\xED')
                .replace(/\\xEE/g, '\xEE')
                .replace(/\\xEF/g, '\xEF')
                .replace(/\\xF1/g, '\xF1')
                .replace(/\\xF2/g, '\xF2')
                .replace(/\\xF3/g, '\xF3')
                .replace(/\\xF4/g, '\xF4')
                .replace(/\\xF6/g, '\xF6')
                .replace(/\\xF9/g, '\xF9')
                .replace(/\\xFB/g, '\xFB')
                .replace(/\\xFC/g, '\xFC')
                .replace(/\\xC0/g, '\xC0')
                .replace(/\\xC2/g, '\xC2')
                .replace(/\\xC7/g, '\xC7')
                .replace(/\\xC8/g, '\xC8')
                .replace(/\\xC9/g, '\xC9')
                .replace(/\\xCA/g, '\xCA')
                .replace(/\\xCB/g, '\xCB')
                .replace(/\\xCE/g, '\xCE')
                .replace(/\\xCF/g, '\xCF')
                .replace(/\\xD1/g, '\xD1')
                .replace(/\\xD4/g, '\xD4')
                .replace(/\\xD9/g, '\xD9')
                .replace(/\\xDB/g, '\xDB')
                .replace(/\\xDC/g, '\xDC');
        }
        return text;
    };
    
    var decryptISO = function(text) {
        return eval('"' + text + '"');
    };

	/* http://www.jquerybyexample.net/2012/06/get-url-parameters-using-jquery.html */
	var getUrlParameter = function(sParam) {
		var sPageURL = window.location.search.substring(1);
		var sURLVariables = sPageURL.split('&');
		for (var i = 0; i < sURLVariables.length; i++) {
			var sParameterName = sURLVariables[i].split('=');
			if (sParameterName[0] == sParam) {
				return sParameterName[1];
			}
		}
	};

	// from Tokan
	var formatNumberToMoney = function(number) {
		if (typeof number == "string") {
			number = parseFloat(number.replace(',', '.'));
		}
		if (isNaN(number)) {
			return null;
		}
		var lang = $("html").attr('lang');
		var moneyString = "";
		if (lang !== 'fr') { moneyString += '$'; }
		moneyString += number.toFixed(2);
		if (lang == 'fr') { 
			moneyString = moneyString.replace(".", ",");
			moneyString += '$'; 
		}
		return moneyString;
	};


	Fw.component.export('utils', {
		recaptcha: recaptcha,
		updateItemTop: updateItemTop,
		decodeText: decodeText,
		decryptISO: decryptISO,
		getUrlParameter: getUrlParameter,
		formatNumberToMoney: formatNumberToMoney
	});

})(jQuery);
